// Seitliches Scrollen mit Trackpad und Maus in DevExtreme-Tabellen (Kundenwunsch 17.10.2026: „wenn man mit dem
// touchpad mac in der tabelle auch horizontal scrollen könnte“). Die Tabellen nutzen das simulierte Scrollen von
// DevExtreme (useNative: false, Balken nur beim Überfahren; DataGridMixin), das nur die senkrechte Radbewegung
// auswertet. Dieser Handler gibt eine überwiegend seitliche Bewegung (deltaX) über Kopf, Filterzeile oder Daten an den
// Scrollbereich der Tabelle weiter (der Kopf läuft mit) und verhindert dabei die Wisch-Navigation des Browsers
// (zurück/vor), solange die Tabelle seitlich scrollen kann. Senkrechtes Scrollen bleibt bei DevExtreme.
import Scrollable from 'devextreme/ui/scroll_view/ui.scrollable';

// Zeilen- bzw. Seitenschritte (deltaMode 1/2, z. B. seitliches Mausrad) in Pixel
const LINE_PX = 40;
const PAGE_PX = 400;

function pixels(e) {
  if (e.deltaMode === 1) {
    return e.deltaX * LINE_PX;
  }
  return e.deltaMode === 2 ? e.deltaX * PAGE_PX : e.deltaX;
}

function onWheel(e) {
  if (!e.deltaX || Math.abs(e.deltaX) <= Math.abs(e.deltaY)) {
    return;
  }
  const target = e.target instanceof Element ? e.target : null;
  const area = target && target.closest('.dx-datagrid-headers, .dx-datagrid-rowsview');
  const grid = area && area.closest('.dx-datagrid');
  const rows = grid && grid.querySelector('.dx-datagrid-rowsview.dx-scrollable');
  const scrollable = rows && Scrollable.getInstance(rows);
  if (!scrollable || scrollable.scrollWidth() <= scrollable.clientWidth() + 1) {
    return;
  }
  e.preventDefault();
  scrollable.scrollBy({ left: pixels(e), top: 0 });
}

let installed = false;

export function installGridWheel() {
  if (installed || typeof document === 'undefined') {
    return;
  }
  installed = true;
  document.addEventListener('wheel', onWheel, { passive: false, capture: true });
}
